import './Sidebar.css';
import Image7 from '../Image/smahaduzzaman-noback.png';
import Swal from 'sweetalert2'

const Sidebar = ({ timeRequired, handleBreakTime }) => {

    const handleCompleted = () => {
        Swal.fire(
            'Good job!',
            'Your Activity is Completed',
            'success'
        )
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <img className='img-fluid img-thumbnail rounded-circle author-img' src={Image7} alt="" />
                </div>
                <div className='d-flex justify-content-center flex-column'>
                    <h3>S M Ahduzzaman</h3>
                    <p className='text-muted'>Pirojpur-4320, BD-88-0</p>
                </div>
            </div>
            <div className="row my-3 tip-top-bg">
                <div className="col-md-4">
                    <h4><span className='fs-3'>75</span><span className="text-muted">kg</span></h4>
                    <p className="text-muted">Weight</p>
                </div>
                <div className="col-md-4">
                    <h4><span className='fs-3'>1.6</span><span className="text-muted">m</span></h4>
                    <p className="text-muted">Height</p>
                </div>
                <div className="col-md-4">
                    <h4><span className='fs-3'>39</span><span className="text-muted">y</span></h4>
                    <p className="text-muted">Age</p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h5>Add a Break</h5>
                </div>
            </div>
            <div className="row mt-2 break-time tip-top-bg py-3">
                <div className="col-md-2 mr-3">
                    <div id='break-btn1' onClick={() => handleBreakTime(document.getElementById('break-btn1'),
                    )} className='btn btn-primary text-white rounded-circle border-0 outline-0'>10s</div>
                </div>
                <div className="col-md-2 mr-3">
                    <div id='break-btn2' onClick={() => handleBreakTime(document.getElementById('break-btn2'),
                    )} className='btn btn-danger text-white rounded-circle border-0 outline-0'>20s</div>
                </div>
                <div className="col-md-2 mr-3">
                    <div id='break-btn3' onClick={() => handleBreakTime(document.getElementById('break-btn3'),
                    )} className='btn btn-primary text-white rounded-circle border-0 outline-0'>30s</div>
                </div>
                <div className="col-md-2 mr-3">
                    <div id='break-btn4' onClick={() => handleBreakTime(document.getElementById('break-btn4'),
                    )} className='btn btn-primary text-white rounded-circle border-0 outline-0'>40s</div>
                </div>
            </div>
            <div className="row my-3">
                <div className="col-md-12">
                    <h5>Exercise Details</h5>
                </div>
            </div>
            <div className="row tip-top-bg">
                <div className="col-md-6">
                    <h6>Exercise time</h6>
                </div>
                <div className="col-md-6">
                    <h6 className='text-muted'><span id='exercise-time'>00</span> seconds</h6>
                </div>
            </div>
            <div className="row my-3 tip-top-bg">
                <div className="col-md-6">
                    <h6>Break time</h6>
                </div>
                <div className="col-md-6">
                    <h6 className='text-muted'><span id='break-time'>00</span> seconds</h6>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <button onClick={handleCompleted} className='btn btn-primary'>Activity Completed</button>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;